// pages/CuratedSelection.jsx
import React from 'react';
import ProductCategories from '../components/ProductCategories';
import ProductCarousel from '../components/ProductCarousel';
import ImageTextBlock from 'blocks/ImageTextBlock';
import ProductBlock from '../components/ProductBlock';
import SEO from '../components/SEO';
// import PhysFilterNavbar from '../components/PhysFilterNavbar'; // sin uso actual
// import PhysHomeProducts from '../components/PhysHomeProducts'; // Removed
import PhysRecommendedReading from '../components/PhysRecommendedReading'; // Sección Recommended Reading
import PhysGiftsSection from '../components/PhysGiftsSection'; // Solo la sección gifts
import { useProducts } from '../hooks/useProducts';
import './CuratedSelection.css';

// ============================================
// SELECCIÓN — por handle del producto en Medusa
// ============================================
// Últimos lanzamientos: carousel + grid "Novedades y lanzamientos".
const LAUNCH_HANDLES = [
  'crema-rica-humectante',
  'soma-lacta-phase-i-serum',
  'soma-tonic-phase-ii',
  'resurge-advance-phase-i-serum',
  'resurge-tonic-phase-2',
];
const ESSENTIAL_HANDLES = [
  'serum-facial-niacinamida',
  'niacinamida-15-fps',
  'serum-vitamina-c-pura-12-20',
  'limpiador-a-la-miel',
];
const KIT_HANDLES = [
  'antiox-protect-glow-set',
  'kit-minimalista-basico',
  'the-journey-kit-iii',
  'the-journey-kit-ii',
];

// Importa tus imágenes si las tienes
// import articleImage from '../assets/pictures/niacinamida.jpg';

const CuratedSelection = () => {
  
  // Productos reales del backend (precio, stock y variantes al día).
  const { allProducts } = useProducts();
  const byHandles = (handles) =>
    handles
      .map((h) => allProducts.find((p) => p.handle === h))
      .filter(Boolean); // un handle que no exista en este backend se omite

  const latestLaunches = byHandles(LAUNCH_HANDLES).map((p) => ({ ...p, badge: p.badge || 'launch' }));
  const essentials = byHandles(ESSENTIAL_HANDLES);
  const kits = byHandles(KIT_HANDLES);

  // ============================================
  // DATOS PARA EL ARTÍCULO
  // ============================================
  const articleData = {
    title: 'Niacinamida: ciencia, calma y memoria celular',
    miniTitle: '', // Opcional
    desc: 'No es solo un ingrediente. Es el recordatorio de que la piel tiene la capacidad de sanar, recordar y volver a su equilibrio natural.',
    btn: 'Ver Artículo',
    // img: articleImage // Descomenta cuando tengas la imagen
  };

  return (
    <div className="curated-selection-page" data-header-theme="light">
      <SEO
        title="Selección curada — Rituales y kits Physiology"
        description="Una selección curada por Physiology Skincare Co: rituales, kits y combinaciones diseñadas para cada tipo de piel y momento del día."
        path="/curated-selection"
      />

      {/* ============================================
          HERO SECTION
          ============================================ */}
      <section className="curated-hero">
        <div className="curated-hero-content">
          <h1 className="curated-hero-title">Selección curada</h1>
          <p className="curated-hero-description">
            Creemos que tu piel merece lo esencial, nada más y nada menos. 
            Cada ingrediente ha sido seleccionado con cuidado, no solo por lo que aporta, 
            sino también por lo que evita: exceso, irritación, y complicaciones innecesarias. 
            Aquí, menos es realmente más.
          </p>
        </div>
      </section>

      {/* ============================================
          NAVBAR CON FILTROS PHYS (unida al grid)
          ============================================ */}
      {/* PhysFilterNavbar oculto — reutilizar en otra página
      <PhysFilterNavbar />
      */}

      {/* PhysHomeProducts removed */}

      {/* ============================================
          GRID DE CATEGORÍAS
          ============================================ */}
      <ProductCategories />

      {/* ============================================
          CAROUSEL DE ÚLTIMOS LANZAMIENTOS
          ============================================ */}
      {latestLaunches.length > 0 && (
        <section className="curated-carousel-section">
          <ProductCarousel
            products={latestLaunches}
            title="Los últimos lanzamientos"
            showBadges={true}
          />
        </section>
      )}

      {/* ============================================
          ARTÍCULO DESTACADO (NIACINAMIDA)
          ============================================ */}
      <ImageTextBlock
        title={articleData.title}
        miniTitle={articleData.miniTitle}
        desc={articleData.desc}
        btn={articleData.btn}
        img="/images/secciones/curated-selection/cream4.webp"
        even={false}
      />

      {/* curated-real-products-section removed */}

      {/* ============================================
          BLOQUES ADICIONALES DE PRODUCTOS
          ============================================ */}
      <ProductBlock 
        title="Esenciales en tu rutina" 
        description="Productos fundamentales que no pueden faltar en tu cuidado diario"
        buttonText="Ver todos los esenciales"
        buttonTo="/shop?badge=essential"
        products={essentials}
      />

      <ProductBlock 
        title="Novedades y lanzamientos"
        description="Descubre nuestros productos más recientes e innovadores"
        buttonText="Ver novedades"
        buttonTo="/shop?badge=launch"
        products={latestLaunches.slice(0, 4)}
      />

      {/* ============================================
          HERO SECTION REPETIDO (2 BLOQUES ARRIBA)
          ============================================ */}
      <section className="curated-hero">
        <div className="curated-hero-content">
          <h1 className="curated-hero-title">Selección curada</h1>
          <p className="curated-hero-description">
            Creemos que tu piel merece lo esencial, nada más y nada menos. 
            Cada ingrediente ha sido seleccionado con cuidado, no solo por lo que aporta, 
            sino también por lo que evita: exceso, irritación, y complicaciones innecesarias. 
            Aquí, menos es realmente más.
          </p>
        </div>
      </section>

      <ProductBlock 
        title="Kits y sets recomendados"
        description="Combinaciones perfectas para rutinas completas"
        buttonText="Ver todos los kits"
        buttonTo="/shop?category=kits"
        products={kits}
      />

      {/* ============================================
          SECCIÓN RECOMMENDED READING (arriba de gifts)
          ============================================ */}
      <PhysRecommendedReading />

      {/* ============================================
          SECCIÓN GIFTS (al final de la página)
          ============================================ */}
      <PhysGiftsSection />

    </div>
  );
};

export default CuratedSelection;
